import React, { ReactElement } from "react";
import { IconProps } from "./types";

export const BankIcon = ({
  width = "31",
  height = "32",
  fill = "#000",
}: IconProps): ReactElement => {
  return (
    <div data-testid="Bank_Icon">
      <svg
        width={width}
        height={height}
        fill={fill}
        viewBox="0 0 23 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7225_157)">
          <path d="M11.4993 3.27173C10.3457 3.27173 9.40723 4.251 9.40723 5.45476C9.40723 6.65851 10.3457 7.63778 11.4993 7.63778C12.6529 7.63778 13.5914 6.65851 13.5914 5.45476C13.5914 4.251 12.6529 3.27173 11.4993 3.27173ZM11.4993 6.54653C10.9225 6.54653 10.453 6.05663 10.453 5.45476C10.453 4.85288 10.9225 4.36299 11.4993 4.36299C12.0761 4.36299 12.5456 4.85288 12.5456 5.45476C12.5456 6.05663 12.0761 6.54653 11.4993 6.54653Z" />
          <path d="M22.4776 9.81808C22.7667 9.81808 23.0005 9.5757 23.0005 9.27399V7.0925C23.0005 6.90022 22.9035 6.72176 22.7447 6.62357L12.5191 0.287221C12.5147 0.284153 12.5098 0.281596 12.5054 0.278528C11.8698 -0.089145 11.1533 -0.100395 10.4809 0.286199L0.255811 6.62357C0.0970319 6.72176 0 6.90022 0 7.0925V9.27399C0 9.57518 0.233759 9.81808 0.522894 9.81808H2.09109V19.6368C0.937975 19.6368 0 20.6151 0 21.8183V23.4547C0 23.7559 0.233759 24.0003 0.522894 24.0003H22.4776C22.7667 24.0003 23.0005 23.7564 23.0005 23.4547V21.8183C23.0005 20.6151 22.0625 19.6368 20.9094 19.6368V9.81808H22.4776ZM21.9547 21.8183V22.9091H1.0453V21.8183C1.0453 21.217 1.51429 20.7276 2.0906 20.7276H20.9094C21.4857 20.7276 21.9547 21.217 21.9547 21.8183ZM3.13639 19.6363V9.81808H5.22747V19.6363H3.13639ZM6.27277 19.6363V9.81808H9.40916V19.6363H6.27277ZM10.4545 19.6363V9.81808H12.5455V19.6363H10.4545ZM13.5908 19.6363V9.81808H16.7272V19.6363H13.5908ZM17.7725 19.6363V9.81808H19.8636V19.6363H17.7725ZM1.0453 8.72734V7.40136L10.9994 1.23069C11.3253 1.04353 11.6713 1.04404 11.9928 1.22711L21.9547 7.40136V8.72734H1.0453Z" />
        </g>
        <defs>
          <clipPath id="clip0_7225_157">
            <rect width="23" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
